import { styled } from '@withjoy/joykit';

interface CheckboxProps {
  checkedBackgroundColor?: string;
}

interface LabelProps {}

// Not a text field, and not convertible: a checkbox behind a custom SVG label. It is NOT a
// sanctioned hidden input either -- `display: none` takes it out of the tab order entirely, unlike
// the `opacity: 0` pattern the others use, so the control is mouse-only across its five consumers.
// That is a keyboard-reachability bug rather than field-chrome drift, and is tracked separately;
// see EXCEPTIONS.md, "Not exceptions -- known debt".
// eslint-disable-next-line no-restricted-syntax -- checkbox behind a custom label, see above
export const Input = styled.input<CheckboxProps>`
  display: none;
  :checked + label .checkbox_svg__checkmark {
    opacity: 1;
  }

  :checked + label .checkbox_svg__check-circle {
    fill: ${({ checkedBackgroundColor }) => checkedBackgroundColor || '#66bab5'};
    stroke: ${({ checkedBackgroundColor }) => checkedBackgroundColor || '#66bab5'};
  }
`;

export const Label = styled.label<LabelProps>`
  width: 24px;
  height: 24px;
  display: block;
  svg {
    width: 24px;
    height: 24px;
    display: block;
  }
  .checkbox_svg__checkmark {
    opacity: 0;
    transition: opacity 0.25s ease-out;
  }
  :hover {
    cursor: pointer;
  }
`;
